var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-10 mt-7" },
    [
      _c("ActionPanel", {
        staticClass: "mb-4",
        attrs: { total: _vm.getTotal, pageName: `Total Requests` },
      }),
      _vm.isAdmin
        ? _c(
            "div",
            { staticClass: "w-1/4 flex flex-row mb-9" },
            [
              _c(
                "FormGroup",
                { staticClass: "mr-14" },
                [
                  _c("RadioButtonGroup", {
                    attrs: { options: _vm.radioOptions },
                    model: {
                      value: _vm.requestsStatus,
                      callback: function ($$v) {
                        _vm.requestsStatus = $$v
                      },
                      expression: "requestsStatus",
                    },
                  }),
                ],
                1
              ),
              _c("FormGroup", {
                staticClass: "w-full",
                attrs: {
                  type: "search",
                  isIcon: true,
                  iconStyle: "customIcon",
                  inputClass: "customFormInput",
                  placeholder: "Search by name",
                  debounceTime: 500,
                },
                model: {
                  value: _vm.nameValue,
                  callback: function ($$v) {
                    _vm.nameValue = $$v
                  },
                  expression: "nameValue",
                },
              }),
            ],
            1
          )
        : _c(
            "div",
            [
              _c("FormGroup", {
                staticClass: "w-full mb-9",
                attrs: {
                  type: "search",
                  iconStyle: "customIcon",
                  inputClass: "customFormInput",
                  isIcon: true,
                  placeholder: "Search by name",
                  debounceTime: 500,
                },
                model: {
                  value: _vm.nameValue,
                  callback: function ($$v) {
                    _vm.nameValue = $$v
                  },
                  expression: "nameValue",
                },
              }),
            ],
            1
          ),
      _c(
        "LoadingOverlay",
        { attrs: { hasData: _vm.hasData, loading: _vm.loading } },
        [
          _vm.isActiveRequests
            ? _c(
                "div",
                [
                  _vm.emptyActive
                    ? _c("EmptyListPlaceholder", {
                        attrs: { title: _vm.emptyListPlaceholder },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image",
                              fn: function () {
                                return [_c("EmptyListImageRequests")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2557147869
                        ),
                      })
                    : [
                        _c(
                          "div",
                          { staticClass: "flex flex-wrap flex-row gap-4" },
                          _vm._l(_vm.requests, function (request) {
                            return _c("RequestCard", {
                              key: request.id,
                              attrs: {
                                contractorUser: request.contractor.user,
                                managerUser: request.manager.user,
                                contractorApproved: request.contractor.approved,
                                requestId: request.id,
                                contractorId: request.contractor.id,
                                currentUserRole: _vm.currentUser.role,
                                requestDate: request.created_at,
                                managerId: request.manager.id,
                              },
                              on: { refetch: _vm.refetch },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "requestedBy",
                                    fn: function () {
                                      return [
                                        _vm.showRequestedBy
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-2",
                                              },
                                              [
                                                _c("UserIcon", {
                                                  staticClass:
                                                    "pr-2 w-auto h-auto",
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-primary-black font-400 text-sm pr-2",
                                                  },
                                                  [_vm._v("Requested by")]
                                                ),
                                                _c("ItemChip", {
                                                  staticClass: "mt-2",
                                                  attrs: {
                                                    itemId: request.manager.id,
                                                    itemName: _vm.getFullName(
                                                      request.manager.user
                                                    ),
                                                    avatar:
                                                      request.manager.user
                                                        .avatar,
                                                    routeName:
                                                      _vm.routes.MANAGER_ABOUT,
                                                    isPerson: "",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }),
                          1
                        ),
                        _vm.showActivePagination
                          ? _c("CardPagination", {
                              attrs: { config: _vm.requestCardsConfig },
                              on: {
                                "update:config": function ($event) {
                                  _vm.requestCardsConfig = $event
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm.archivedCardsForAdmin
            ? _c(
                "div",
                [
                  _vm.emptyArchived
                    ? _c("EmptyListPlaceholder", {
                        attrs: {
                          title: "There are no archived requests at the moment",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image",
                              fn: function () {
                                return [_c("EmptyListImageRequests")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2557147869
                        ),
                      })
                    : [
                        _c(
                          "div",
                          { staticClass: "flex flex-wrap flex-row gap-4" },
                          _vm._l(
                            _vm.archivedContractors,
                            function (contractor, index) {
                              return _c("ArchivedRequestContractorCard", {
                                key: index,
                                attrs: {
                                  contractor: contractor,
                                  contractorApproved: contractor.approved,
                                },
                                on: {
                                  refetchArchived: _vm.handleArchivedRefetch,
                                  refetchRequestsContractorsNumber: function (
                                    $event
                                  ) {
                                    return _vm.$emit(
                                      "refetchRequestsContractorsNumber"
                                    )
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                        _vm.showArchivedPagination
                          ? _c("CardPagination", {
                              attrs: { config: _vm.archivedRequestsConfig },
                              on: {
                                "update:config": function ($event) {
                                  _vm.archivedRequestsConfig = $event
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                ],
                2
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }